"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOfferUnderBuyerUserDto = instanceOfOfferUnderBuyerUserDto;
exports.OfferUnderBuyerUserDtoFromJSON = OfferUnderBuyerUserDtoFromJSON;
exports.OfferUnderBuyerUserDtoFromJSONTyped = OfferUnderBuyerUserDtoFromJSONTyped;
exports.OfferUnderBuyerUserDtoToJSON = OfferUnderBuyerUserDtoToJSON;
exports.OfferUnderBuyerUserDtoToJSONTyped = OfferUnderBuyerUserDtoToJSONTyped;
/**
 * Check if a given object implements the OfferUnderBuyerUserDto interface.
 */
function instanceOfOfferUnderBuyerUserDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('isVerified' in value) || value['isVerified'] === undefined)
        return false;
    return true;
}
function OfferUnderBuyerUserDtoFromJSON(json) {
    return OfferUnderBuyerUserDtoFromJSONTyped(json, false);
}
function OfferUnderBuyerUserDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'isVerified': json['isVerified'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
    };
}
function OfferUnderBuyerUserDtoToJSON(json) {
    return OfferUnderBuyerUserDtoToJSONTyped(json, false);
}
function OfferUnderBuyerUserDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'fullName': value['fullName'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'countryCode': value['countryCode'],
        'isVerified': value['isVerified'],
        'avatarUrl': value['avatarUrl'],
    };
}
